export default {
  billingPeriodId: {
    isRequiredTrim: {
      value: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/reports/forms/dependentPersonCoveragesTerminations/dependentPersonCoveragesTerminationsValidationRules.js